<div class="min-h-screen bg-slate-50 text-slate-700">
  <div class="mx-auto w-full max-w-[96rem] px-6 py-6">
    <div class="flex flex-wrap items-center justify-between gap-4">
      <div class="flex flex-wrap items-center gap-4">
        <label class="relative">
          <span class="sr-only">Filter by user type</span>
          <select
            class="h-9 rounded-md border border-slate-200 bg-white px-3 pr-8 text-sm text-slate-700 shadow-sm"
            [value]="selectedUserType()"
            (change)="onUserTypeChange($event)"
          >
            @for (option of userTypeOptions; track option.value) {
              <option [value]="option.value">
                {{ option.label }}
              </option>
            }
          </select>
        </label>

        <div class="text-sm text-slate-600">
          Total Accounts:
          <span class="font-semibold text-slate-900">{{ totalAccounts() }}</span>
        </div>
      </div>
    </div>

    <div class="mt-4 overflow-x-auto rounded-lg border border-slate-200 bg-white shadow-sm">
      <table class="min-w-[1400px] w-full text-left text-sm">
        <thead class="border-b border-slate-200 bg-slate-50 text-slate-600">
          <tr>
            <th class="px-4 py-3" [attr.aria-sort]="ariaSort('name')">
              <button class="inline-flex items-center gap-2" (click)="onSort('name')">
                <span>Name</span>
                <span class="material-icons text-slate-400">{{ sortIndicator('name') }}</span>
              </button>
            </th>
            <th class="px-4 py-3" [attr.aria-sort]="ariaSort('email')">
              <button class="inline-flex items-center gap-2" (click)="onSort('email')">
                <span>Email</span>
                <span class="material-icons text-slate-400">{{ sortIndicator('email') }}</span>
              </button>
            </th>
            <th class="px-4 py-3">
              <button class="inline-flex items-center gap-2">
                <span>Social</span>
              </button>
            </th>
            <th class="px-4 py-3">
              <button class="inline-flex items-center gap-2">
                <span>Tier</span>
              </button>
            </th>
            <th class="px-4 py-3" [attr.aria-sort]="ariaSort('createdOn')">
              <button class="inline-flex items-center gap-2" (click)="onSort('createdOn')">
                <span>Created On</span>
                <span class="material-icons text-slate-400">{{ sortIndicator('createdOn') }}</span>
              </button>
            </th>
            <th class="px-4 py-3">
              <button class="inline-flex items-center gap-2">
                <span>UserType</span>
              </button>
            </th>
            <th class="px-4 py-3" [attr.aria-sort]="ariaSort('lastLogin')">
              <button class="inline-flex items-center gap-2" (click)="onSort('lastLogin')">
                <span>Last Login</span>
                <span class="material-icons text-slate-400">{{ sortIndicator('lastLogin') }}</span>
              </button>
            </th>
            <th class="px-4 py-3" [attr.aria-sort]="ariaSort('acceptedTerms')">
              <button class="inline-flex items-center gap-2" (click)="onSort('acceptedTerms')">
                <span>Accepted T&amp;C</span>
                <span class="material-icons text-slate-400">{{ sortIndicator('acceptedTerms') }}</span>
              </button>
            </th>
            <th class="px-4 py-3" [attr.aria-sort]="ariaSort('charity')">
              <button class="inline-flex items-center gap-2" (click)="onSort('charity')">
                <span>Charity</span>
                <span class="material-icons text-slate-400">{{ sortIndicator('charity') }}</span>
              </button>
            </th>
            <th class="px-4 py-3">
              <button class="inline-flex items-center gap-2">
                <span>Storage Used</span>
              </button>
            </th>
            <th class="px-4 py-3 text-center">Actions</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-100">
          @for (account of accounts(); track account.userName) {
            <tr class="hover:bg-slate-50">
              <td class="px-4 py-4 font-medium text-slate-800">{{ account.name }}</td>
              <td class="px-4 py-4 text-slate-600">{{ account.email }}</td>
              <td class="px-4 py-4 text-slate-600">{{ socialProvider(account) }}</td>
              <td class="px-4 py-4 text-slate-600">
                {{ tierLabel(account) }}
              </td>
              <td class="px-4 py-4 text-slate-600">
                {{ account._createdAt | date: 'dd-MMM-yyyy' }}
              </td>
              <td class="px-4 py-4 text-slate-600">{{ userTypeLabel(account) }}</td>
              <td class="px-4 py-4 text-slate-600">
                @if (account.lastLogin) {
                  {{ account.lastLogin | date: 'dd-MMM-yyyy HH:mm' }}
                } @else {
                  -
                }
              </td>
              <td class="px-4 py-4 text-slate-600">
                {{ account.lastTOSNotificationDate | date: 'dd-MMM-yyyy HH:mm' }}
              </td>
              <td class="px-4 py-4 text-slate-600">
                {{ account.subscription?.charity ?? '-' }}
              </td>
              <td class="px-4 py-4 text-slate-600">{{account.attachmentCount}} Files - {{account.totalStorage | filesize}}</td>
              <td class="px-4 py-4 text-center">
                <button
                  class="rounded-md bg-red-600 px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-red-700"
                  (click)="onDelete(account)"
                >
                  Delete Account
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="mt-3 flex flex-wrap items-center justify-between gap-3 text-xs text-slate-500">
      <div>
        Records Found: {{ recordsFound() }}
      </div>
      <div class="flex items-center gap-2">
        <button
          class="rounded-md border border-slate-200 px-3 py-1 text-xs text-slate-600 disabled:cursor-not-allowed disabled:opacity-50"
          (click)="goToPage(page() - 1)"
          [disabled]="page() === 1"
        >
          Previous
        </button>
        <span class="text-xs text-slate-600">
          Page {{ page() }} of {{ totalPages() }}
        </span>
        <button
          class="rounded-md border border-slate-200 px-3 py-1 text-xs text-slate-600 disabled:cursor-not-allowed disabled:opacity-50"
          (click)="goToPage(page() + 1)"
          [disabled]="page() === totalPages()"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</div>

@if (isDeleteOpen()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4">
    <div class="w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
      <h2 class="text-lg font-semibold text-slate-900">Delete account?</h2>
      <p class="mt-2 text-sm text-slate-600">
        This will remove
        <span class="font-medium text-slate-900">{{ pendingDelete()?.email }}</span>.
        You can’t undo this action.
      </p>
      <div class="mt-6 flex justify-end gap-3">
        <button
          class="rounded-md border border-slate-200 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
          (click)="closeDeleteModal()"
        >
          Cancel
        </button>
        <button
          class="inline-flex items-center gap-2 rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-70"
          (click)="confirmDelete()"
          [disabled]="isDeleting()"
        >
          @if (isDeleting()) {
            <span class="material-icons animate-spin text-white">autorenew</span>
            Deleting...
          } @else {
            Delete Account
          }
        </button>
      </div>
    </div>
  </div>
}
